var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isEmpty } from "lodash";
import { setConnected, setGreeksMsg, setSocket, } from "../redux/reducers/openfeed-ws";
import { store } from "../redux/store";
import { checkAndGetGreeksToken } from "./methods";
import { SOCKET_SUBSCRIPTION_METHODS } from "./constant";
import { getDataFromSession, SESSION_KEYS } from "./session-storage";
import { subscribeToData as subscribeToDataSolace, unsubscribeDataBySubscriber as unsubscribeDataBySubscriberSolace, } from "./solacesocketwrapper";
let socket;
const noOfRetry = 120000;
let count = 0;
let interval;
let dataUpdateInterval;
let socketUrl = undefined;
let isWindowFocused = true;
// let remoteConfig: RemoteConfig | undefined = undefined;
//let remoteConfigData: RemoteConfigDataType | undefined = undefined;
let countForHeartBeat = 0;
let closeTimeoutRef;
let subscriberList = [];
const heartBeatSubscriberList = [];
let isSocketConnected = false;
let isSocketInitLoading = false;
const isSolaceEnabled = () => getDataFromSession(SESSION_KEYS.SOLACE_ENABLED);
// let isDataLoading = false;
let scripMap = {};
const setSocketConnected = (newValue) => {
    isSocketConnected = newValue;
    if (newValue) {
        if (!dataUpdateInterval) {
            dataUpdateInterval = setInterval(() => {
                checkSyncTimeAndDispatchData();
            }, 500);
        }
    }
    else if (dataUpdateInterval) {
        clearInterval(dataUpdateInterval);
        dataUpdateInterval = undefined;
        countForHeartBeat = 0;
    }
};
const checkSyncTimeAndDispatchData = () => {
    // countForHeartBeat++;
    // if (countForHeartBeat == 4) {
    //   countForHeartBeat = 0;
    //   if (isSocketConnected) {
    //     socket?.send("Hi this is a heartbeat message");
    //   }
    // }
    Object.keys(scripMap).forEach((singleScripKey) => {
        const scripObj = scripMap[singleScripKey];
        if (scripObj === null || scripObj === void 0 ? void 0 : scripObj.data) {
            checkAndDispatchSingleMessageAsPerType(scripObj);
        }
    });
};
///
export const subscribeToGreeksData = (subscriptionMethod, subscriberName, callBackMethod) => {
    if (isSolaceEnabled()) {
        subscribeToDataSolace(subscriptionMethod, subscriberName, callBackMethod);
        return;
    }
    let subsData = subscriberList.find((singleSubData) => {
        if (subscriptionMethod.Method === singleSubData.Method) {
            return singleSubData;
        }
    });
    if (subsData) {
        subsData.MarketFeedData.push(...subscriptionMethod.MarketFeedData);
        // scripMap
        subsData.MarketFeedData = arrayUnique(subsData.MarketFeedData);
    }
    else {
        subsData = subscriptionMethod;
        subscriberList.push(subscriptionMethod);
    }
    const uniqueRequestArray = [];
    subscriptionMethod.MarketFeedData.forEach((singleElement) => {
        if (callBackMethod) {
            const isNew = addSingleScripSubscriber(subscriberName, singleElement, callBackMethod, subscriptionMethod.Method);
            if (isNew) {
                uniqueRequestArray.push(singleElement);
            }
            else {
                const scripObj = scripMap[SOCKET_SUBSCRIPTION_METHODS.GREEKS_INSTRUMENT +
                    singleElement.ScripCode];
                if (scripObj === null || scripObj === void 0 ? void 0 : scripObj.data) {
                    checkAndDispatchSingleMessageAsPerType(scripObj);
                }
            }
        }
    });
    if (uniqueRequestArray.length > 0) {
        subscriptionMethod.MarketFeedData = uniqueRequestArray;
    }
    else {
        return;
    }
    if (isWindowFocused) {
        if (isSocketConnected) {
            sendMessage(subscriptionMethod);
        }
        else {
            reSubscribeGreeksSocket();
        }
    }
};
const addSingleScripSubscriber = (subscriberName, marketFeedSingleElement, callBackMethod, methodName) => {
    let scripObj = scripMap[SOCKET_SUBSCRIPTION_METHODS.GREEKS_INSTRUMENT +
        marketFeedSingleElement.ScripCode];
    if (scripObj) {
        const subsObj = scripObj.subscribers.find((singleElement) => {
            const isAlreadySubscribed = singleElement.componentName == subscriberName;
            return isAlreadySubscribed;
        });
        if (subsObj) {
            const alreadySubscribedMethod = subsObj.method.find((singleElement) => {
                return singleElement == methodName;
            });
            if (isEmpty(alreadySubscribedMethod)) {
                subsObj.method.push(methodName);
                return true;
            }
            else {
                return false;
            }
            // subsObj.callback = callBackMethod;
        }
        else {
            scripObj.subscribers.push({
                method: [methodName],
                // callback: callBackMethod,
                componentName: subscriberName,
            });
            return true;
        }
    }
    else {
        scripObj = {
            subscribers: [
                {
                    method: [methodName],
                    // callback: callBackMethod,
                    componentName: subscriberName,
                },
            ],
            data: undefined,
            lastUpdateTime: undefined,
        };
        scripMap[SOCKET_SUBSCRIPTION_METHODS.GREEKS_INSTRUMENT +
            marketFeedSingleElement.ScripCode] = scripObj;
        return true;
    }
};
export const unsubscribeGreekDataBySubscriber = (subscriberName) => {
    if (isSolaceEnabled()) {
        unsubscribeDataBySubscriberSolace(subscriberName);
        return;
    }
    Object.keys(scripMap).forEach((singleScripKey) => {
        unSubscribeDataByScripKey(subscriberName, singleScripKey);
    });
    if (!closeTimeoutRef) {
        closeTimeoutRef = setTimeout(() => {
            if (Object.keys(scripMap).length == 0) {
                closeGreeksWebSocket();
            }
            closeTimeoutRef = undefined;
        }, 3000);
    }
};
export const unsubscribeGreekDataByScrip = (subsriberName, marketFeedSingleElement) => {
    unSubscribeDataByScripKey(subsriberName, getScripKey(marketFeedSingleElement));
};
const unSubscribeDataByScripKey = (subscriberName, singleScripKey) => {
    const scripObj = scripMap[singleScripKey];
    if (scripObj) {
        const newSubList = scripObj.subscribers.filter((singleElement) => {
            return singleElement.componentName != subscriberName;
        });
        if (newSubList.length > 0) {
            scripObj.subscribers = newSubList;
        }
        else {
            delete scripMap[singleScripKey];
        }
    }
};
//
export const heartBeatGreeksData = (subscriptionMethod, subscriberName, callbackMethod) => {
    return subscribeToGreeksData(subscriptionMethod, subscriberName, callbackMethod);
};
const arrayUnique = (array) => {
    const a = array.concat();
    for (let i = 0; i < a.length; ++i) {
        for (let j = i + 1; j < a.length; ++j) {
            if (a[i].ScripCode == a[j].ScripCode)
                a.splice(j--, 1);
        }
    }
    return a;
};
// const compareAndGetNewObjectsArray = (newSubList: SocketDataType[], currSubList: SocketDataType[]): SocketDataType[] =>{}
const getScripKey = (marketFeedSingleElement) => {
    return (
    // marketFeedSingleElement.Exch +
    // marketFeedSingleElement.ExchType +
    SOCKET_SUBSCRIPTION_METHODS.GREEKS_INSTRUMENT +
        marketFeedSingleElement.ScripCode);
};
export const unSubscribeAllGreeksData = () => {
    if (isSolaceEnabled()) {
        //TODO unsubscribe all greek data from solace
        return;
    }
    const cloneData = JSON.parse(JSON.stringify(subscriberList));
    cloneData.forEach((singleSubscription) => {
        singleSubscription.Operation = "unsubscribe";
    });
    sendAllMessage(cloneData);
    scripMap = {};
    subscriberList = [];
    if (!closeTimeoutRef) {
        closeTimeoutRef = setTimeout(() => {
            if (Object.keys(scripMap).length == 0) {
                closeGreeksWebSocket();
            }
            closeTimeoutRef = undefined;
        }, 3000);
    }
};
const sendMessage = (subscriptionMethod) => {
    // if (REACT_APP_ENV === "development") {
    //   subscriptionMethod.ClientCode = "54311569";
    // }
    // console.log(subscriptionMethod, "subscriptionMethod+++++++++++");
    try {
        if (isSocketConnected) {
            const finalJson = {
                method: subscriptionMethod.Operation,
                operation: subscriptionMethod.Method,
                instruments: subscriptionMethod.MarketFeedData.map((singleElement) => {
                    return (SOCKET_SUBSCRIPTION_METHODS.GREEKS_INSTRUMENT +
                        singleElement.ScripCode);
                }),
            };
            socket === null || socket === void 0 ? void 0 : socket.send(JSON.stringify(finalJson));
        }
    }
    catch (error) {
        console.error(error);
    }
};
const sendAllMessage = (localSubscribeList) => {
    localSubscribeList.forEach((singleElement) => {
        sendMessage(singleElement);
    });
};
const updateSocketConnectedStateAndSendData = () => {
    if ((socket === null || socket === void 0 ? void 0 : socket.readyState) == WebSocket.OPEN) {
        setSocketConnected(true);
        sendAllMessage(subscriberList);
    }
    else {
        setTimeout(() => {
            updateSocketConnectedStateAndSendData();
        }, 1000);
    }
};
const onSocketOpen = (event) => {
    const ws = event.currentTarget;
    if (ws instanceof WebSocket) {
        store.dispatch(setSocket(ws));
        store.dispatch(setConnected(true));
        updateSocketConnectedStateAndSendData();
    }
    if (interval) {
        clearInterval(interval);
        interval = undefined;
    }
};
const onSocketMessage = (event) => {
    var _a;
    try {
        let message = ((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.length) > 1 ? JSON.parse(event === null || event === void 0 ? void 0 : event.data) : {};
        if (Array.isArray(message)) {
            message = message[0];
        }
        handleAndDispatchMessage(message);
    }
    catch (error) {
        console.error(error);
    }
    // try {
    //   const greeksData: any = getGreeksDummyData();
    //   store.dispatch(setGreeksMsg(greeksData)); //set Message here from websocket
    // } catch (error) {
    //   console.error(error);
    // }
    // store.dispatch(setMessage(message));
};
const handleAndDispatchMessage = (message) => {
    if (message && message.PacketIdentifier == "G") {
        store.dispatch(setGreeksMsg(message));
        return;
    }
};
const checkAndDispatchSingleMessageAsPerType = (scripObj) => {
    var _a;
    if ((_a = scripObj === null || scripObj === void 0 ? void 0 : scripObj.data) === null || _a === void 0 ? void 0 : _a.greekFeedData) {
        checkAndDispatchSingleMessage(scripObj, scripObj.data.greekFeedData);
    }
};
const checkAndDispatchSingleMessage = (scripObj, selectedSocketResponseSyncObject) => {
    if (!selectedSocketResponseSyncObject.syncTime) {
        dispatchSingleMessage(scripObj, selectedSocketResponseSyncObject);
    }
    else if (selectedSocketResponseSyncObject.syncTime ==
        selectedSocketResponseSyncObject.lastUpdateTime) {
        //DO nothing as latest data is already updated
    }
    else {
        // if (
        //   DATA_UI_REFRESHRATE <=
        //   selectedSocketResponseSyncObject.lastUpdateTime.getTime() -
        //     selectedSocketResponseSyncObject.syncTime.getTime()
        // ) {
        dispatchSingleMessage(scripObj, selectedSocketResponseSyncObject);
        // } else {
        //Do nothing as data is already updated within the winow
        // }
    }
};
const dispatchSingleMessage = (scripObj, selectedSocketResponseSyncObject) => {
    selectedSocketResponseSyncObject.syncTime =
        selectedSocketResponseSyncObject.lastUpdateTime;
    store.dispatch(setGreeksMsg());
};
const onSocketError = (event) => {
    console.error("error event");
    console.error(event);
    handleClose();
};
const onSocketClose = (event) => {
    // console.log("close event");
    // console.log(event);
    handleClose();
};
function handleClose() {
    if (socketUrl == undefined) {
        //this was closed intentionally
        return;
    }
    setSocketConnected(false);
    socket = undefined;
    store.dispatch(setConnected(false));
    store.dispatch(setSocket(null));
    //if (isWindowFocused) {
    //getDataFromMarketFeed();
    //}
    if (interval) {
        return;
    }
    interval = setInterval(() => {
        if (count >= noOfRetry) {
            if (interval)
                clearInterval(interval);
            interval = undefined;
            // console.error("No of retry for connection exceeds");
            return;
        }
        reSubscribeGreeksSocket();
        count = count + 1;
    }, 5000);
}
export const closeGreeksWebSocket = () => {
    // isWindowFocused = false;
    if (isSolaceEnabled()) {
        return;
    }
    if (isSocketConnected && socket) {
        socket.close();
        //console.log("SOCKET CLOSED");
        isSocketConnected = false;
        socket = undefined;
        socketUrl = undefined;
    }
};
// export const reconnectDepthSocket = (localClientCode: string): void => {
//   // if (isSocketConnected) {
//   //   return;
//   // }
//   try {
//     if (socket) {
//       socket.close();
//     }
//   } catch (error) {
//     console.error(error);
//   }
//   if (socketUrl) {
//     initGreeksSocket(socketUrl, true);
//   } else {
//     greeksSocketInit(true);
//   }
// };
export const reSubscribeGreeksSocket = () => {
    // if (isSocketConnected) {
    //   return;
    // }
    try {
        if (socket) {
            if (isSocketConnected) {
                if (!dataUpdateInterval) {
                    dataUpdateInterval = setInterval(() => {
                        checkSyncTimeAndDispatchData();
                    }, 500);
                }
                //console.log(subscriberList, "subscriberList----------");
                sendAllMessage(subscriberList);
            }
            else {
                //Socket is trying to connect and will get connected and get subscribed anyway
            }
            // socket.close();
        }
        else if (isSocketInitLoading) {
            //Do nothing as socket init is already called
        }
        else {
            greeksSocketInit(true);
        }
    }
    catch (error) {
        console.error(error);
    }
};
//Socket Connection Establish
export const initGreeksSocket = (wsUrl, localIsWindowFocus) => {
    if (localIsWindowFocus) {
        isWindowFocused = true;
    }
    isSocketInitLoading = true;
    socketUrl = wsUrl;
    return new Promise((resolve, reject) => {
        try {
            if (!wsUrl || !isWindowFocused || isSocketConnected) {
                return;
            }
            socketUrl = wsUrl;
            socket = new WebSocket(wsUrl);
            socket.onopen = onSocketOpen;
            socket.onmessage = onSocketMessage;
            socket.onerror = onSocketError;
            socket.onclose = onSocketClose;
            resolve(socket);
        }
        catch (err) {
            reject(err);
        }
        finally {
            isSocketInitLoading = false;
        }
    });
};
//Get Access Token and create URL
export const greeksSocketInit = (localIsWindowFocus) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        isSocketInitLoading = true;
        const accessToken = yield checkAndGetGreeksToken();
        const srcPoint = 21;
        if (accessToken) {
            const swarajWsurl = `wss://chartfeedssocket.5paisa.com/ws?access_token=${accessToken}&srcPoint=${srcPoint}`;
            yield initGreeksSocket(swarajWsurl, localIsWindowFocus);
        }
        else {
            setTimeout(() => {
                greeksSocketInit(localIsWindowFocus);
            }, 3000);
        }
        // }
    }
    catch (err) {
        console.error(err);
        isSocketInitLoading = false;
    }
    finally {
        isSocketInitLoading = false;
    }
});
// const randomMessageGenerator = (isEven: boolean): void => {
//   let seconds = new Date().getSeconds();
//   //This is done so ticker size is 5 paisa only
//   if (seconds > 5) {
//     seconds = seconds - (seconds % 5);
//   } else {
//     seconds = 0;
//   }
//   Object.keys(scripMap).forEach((singleKey) => {
//     const scripObj: SocketScripObject = scripMap[singleKey];
//     if (scripObj && scripObj.subscribers.length > 0) {
//       if (scripObj.data?.marketFeedData?.response) {
//         const dataToSend: OpenFeedSocketRespType = {
//           ...scripObj.data?.marketFeedData.response,
//         };
//         // dataToSend.PClose = dataToSend.PClose;
//         dataToSend.LastRate = dataToSend.LastRate + seconds / 100;
//         store.dispatch(setOptionChainMsg(dataToSend));
//       } else if (scripObj.data?.openInterest?.response) {
//         const dataToSend = { ...scripObj.data?.openInterest.response };
//         dataToSend.LastRate = dataToSend.OpenInterest + seconds * 100000;
//         store.dispatch(setOptionChainMsg(dataToSend));
//       } else if (scripObj.data?.marketDepthData?.response) {
//         const dataToSend = { ...scripObj.data?.marketDepthData.response };
//         if (dataToSend.Details.length == 0) {
//           dataToSend.Details.push({
//             Quantity: 999,
//             Price: 123,
//             NumberOfOrders: 100,
//             BbBuySellFlag: 66,
//           });
//         }
//         dataToSend.Details[0].Price =
//           dataToSend.Details[0].Price + seconds / 100;
//         dataToSend.Details[0].Quantity =
//           dataToSend.Details[0].Quantity + seconds;
//         dataToSend.Details[0].NumberOfOrders =
//           dataToSend.Details[0].NumberOfOrders + seconds;
//         store.dispatch(setOptionChainMsg(dataToSend));
//       }
//     }
//   });
//   setTimeout(() => {
//     randomMessageGenerator(isEven);
//   }, 1000);
// };
// if (REACT_APP_ENV == "staging" || REACT_APP_ENV == "development") {
//   randomMessageGenerator(true);
// }
